import { useAppConstantsContext } from '@/context/AppConstants';
import { Link, Stack } from '@/theme/index';
import { useScreenSize } from '@/utils/index';

interface MobileAppsCtaButtonsProps {
  stackDirectionOverride?: 'row' | 'column';
}

export const MobileAppsCtaButtons: React.FC<MobileAppsCtaButtonsProps> = ({
  stackDirectionOverride,
}) => {
  const {
    links: { brandAndroidUrl, brandIosUrl },
    images: { imgAppStoreBadge, imgGooglePlayBadge },
  } = useAppConstantsContext();

  const { isMobile, isTablet } = useScreenSize();

  const midSizeScreen = isTablet && !isMobile;
  return (
    <Stack
      direction={stackDirectionOverride || (midSizeScreen ? 'column' : 'row')}
      spacing={2}
    >
      <Link target="_blank" href={brandIosUrl} rel="noopener noreferrer">
        <img
          src={imgAppStoreBadge}
          alt="Download on the app store"
          width={midSizeScreen ? '105px' : ''}
        />
      </Link>
      <Link target="_blank" href={brandAndroidUrl} rel="noopener noreferrer">
        <img
          src={imgGooglePlayBadge}
          alt="Get it on Google Play"
          width={midSizeScreen ? '105px' : ''}
        />
      </Link>
    </Stack>
  );
};
